/**
 * This is the vertex shader for the "mask" program.
 * 
 * It takes in positions and transforms them using a matrix supplied by mapbox.
 */

attribute vec2 aPos; // We use this to pass in the positions of the vertices.
uniform mat4 uMatrix; // We use this to pass in the matrix that will be used to transform the vertices

void main() {
  // Transform the vertex position via the matrix:
  gl_Position = uMatrix * vec4(aPos, 0, 1);
}
